<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import AuditLog from './auditLog'
import { Helper } from '@/mixin/helper'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Log History',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    AuditLog
  },
  handleSubmit() {
    this.$nextTick(() => {
      this.$bvModal.hide('modal-set')
    })
  },
  computed: {
    title() {
      return 'Log History'
    },
  },
  mixins: [Helper],
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">Audit Log</span>
            </template>
            <AuditLog />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
